import { useContext } from 'react';
import {
    Typography,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    CircularProgress,
} from '@mui/material';
import { ProjectsContext } from './ProjectsContext';

const DeleteProjectDialog = () => {
    const {
        deleteDialogOpen,
        handleCloseDeleteDialog,
        handleDelete,
        currentProject,
        loading,
    } = useContext(ProjectsContext);
    return (
        <Dialog open={deleteDialogOpen} onClose={handleCloseDeleteDialog}>
            <DialogTitle>Confirm Delete</DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to delete the project "
                    {currentProject?.title}"? This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDeleteDialog}>Cancel</Button>
                <Button
                    onClick={handleDelete}
                    variant="contained"
                    color="error"
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} /> : 'Delete'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteProjectDialog;
